import * as React from "react";
import { WxBanner } from "../../components/wx-banner";
import { HorizontalCards } from "../../components/horizontal-cards";
import { VerticalCard } from "../../components/vertical-card";
import { WxOurInfomation } from "../../components/our-infomation";
import { ScrollBrand } from "./scroll-brand";
import { Footer, Icon } from "@/components";
import { WxAdPop } from './ad-pop';
import { bannerHomeImg, FOOTER_CONTENT, SEO } from "@/constants/wxHomepage";
import { genBlock } from "@/utils/bem";
import { isWap } from "@/utils/tools";
import "./style.less";

const getTotalTime = () => {
  /** 2014-01-01 从这天开始计时 */
  const startTime = 1388505600000;
  const diff = new Date().getTime() - startTime;

  return {
    day: Math.floor(diff / ( 1000 * 60 * 60 * 24)),
    year: Math.floor(diff / ( 1000 * 60 * 60 * 24 * 365))
  }
}

const TIP_DATA_ARR = [
  ["免费服务", getTotalTime().year, "年"],
  ["稳定执行", getTotalTime().day, "天"],
  ["每天执行", "1000+", "群发"],
  ["触达", "千万", "级别粉丝"],
];

const CARD_ARR = [
  {
    img: require("@/assets/images/wx/img/mass.png"),
    title: "群发功能",
    desc: (
      <span>
        模板消息群发工具、客服消息群发工具
        <br />
        不占用推送额度、让消息快速触达粉丝
      </span>
    ),
    linkText: "查看功能介绍",
    linkClick: "/wx/mass",
  },
  {
    img: require("@/assets/images/wx/img/qrcode.png"),
    title: "渠道二维码",
    desc: (
      <span>
        生成公众号渠道二维码、地推员二维码
        <br />
        设置个性化回复、统计渠道关注量、留存率
      </span>
    ),
    linkText: "查看功能介绍",
    linkClick: "/wx/qrcode",
  },
  {
    img: require("@/assets/images/wx/img/poster.png"),
    title: "裂变海报",
    desc: (
      <span>
        兼容快站电商、积分系统
        <br />
        快速裂变、高效涨粉
      </span>
    ),
    linkText: "查看功能介绍",
    linkClick: "/wx/poster",
  },
  {
    img: require("@/assets/images/wx/img/auto-reply.png"),
    title: "自动回复",
    desc: (
      <span>
        关注回复、关键词回复、收到消息回复
        <br />
        支持小程序卡片回复、关注后多条延时回复
      </span>
    ),
    linkText: "查看功能介绍",
    linkClick: "/wx/auto-reply",
  },
  {
    img: require("@/assets/images/wx/img/menu.png"),
    title: "自定义菜单",
    desc: (
      <span>
        个性化菜单
        <br />
        针对不同粉丝展示不同内容
      </span>
    ),
    linkText: "查看功能介绍",
    linkClick: "/wx/menu",
  },
];

const CASE_DATA = [
  
  {
    img: require('@/assets/images/wx/case-qrcode/kz.jpg'),
    title: "快站",
  },
  {
    img: require('@/assets/images/wx/case-qrcode/gfr.jpg'),
    title: "冲呀干饭人",
  },
  {
    img: require('@/assets/images/wx/case-qrcode/kzbk.png'),
    title: "快站百科",
  },
  {
    img: require('@/assets/images/wx/case-qrcode/dbz.png'),
    title: "大暴诈",
  },
  {
    img: require('@/assets/images/wx/case-qrcode/zgzx.png'),
    title: "众工在线平台",
  },
];

const BrandList = [
  {
    img: require("@/assets/images/wx/brand/cy.png"),
    title: "畅言云评",
    position: { top: 15, right: "0%" },
    itemStyle: { padding: "2.5%" },
    url: "http://changyan.kuaizhan.com/",
  },
  {
    img: require("@/assets/images/wx/brand/km.png"),
    title: "快码",
    position: { top: 20, left: "45%", transform: "translateX(-50%)" },
    itemStyle: { padding: "2%" },
    url: "https://kuaima.kuaizhan.com/",
  },
  {
    img: require("@/assets/images/wx/brand/kz-form.png"),
    title: "快站表单",
    position: { top: 90, right: "0%" },
    itemStyle: { padding: "2%" },
    url: "https://www.kuaizhan.com/v3/survey/list",
  },
  {
    img: require("@/assets/images/wx/brand/kz.png"),
    title: "快站",
    position: { top: 86, left: "50%", transform: "translateX(-50%)" },
    itemStyle: { padding: "0%" },
    url: "https://www.kuaizhan.com",
  },
  {
    img: require("@/assets/images/wx/brand/vote.png"),
    title: "快站投票",
    position: { top: 100, left: "0%" },
    itemStyle: { padding: "2%" },
    url: "https://www.kuaizhan.com/v3/homepage/vote",
  },
  {
    img: require("@/assets/images/wx/brand/xd-mp.png"),
    title: "心动小程序",
    position: { top: 30, left: "0%" },
    itemStyle: { padding: "2%" },
    url: "https://www.kuaizhan.com/v3/homepage/weapp",
  },
];

const block = genBlock("kz-weixin-index");

const WxHome: React.FC<{}> = () => {

  React.useEffect(() => {
    document.querySelector('meta[name="keywords"]').setAttribute('content', SEO.home.keyword);
    document.querySelector('meta[name="description"]').setAttribute('content', SEO.home.description);
  }, [])

  const goWxList = () => {
    if (isWap()) {
        return
    }
    window.location.href = '/v3/weixin/list'
  }

  return (
    <div className={block()}>
      <WxBanner
        img={bannerHomeImg}
        btnText={"立即使用"}
        btnClick={isWap() ? null : "/v3/weixin/list"}
      />
      <div className={block("tip-wrap")}>
        {TIP_DATA_ARR.map((item) => (
          <div className={block("tip-item")}>
            {item[0]}
            <span className={block("tip-light")}>{item[1]}</span>
            {item[2]}
          </div>
        ))}
      </div>
      <HorizontalCards
        cards={CARD_ARR}
        title="五大功能模块"
        style={{ backgroundColor: "#F4F8FF" }}
      />
      <div className={block("case")}>
        <div className={block("case-title")}>优秀公众号案例</div>
        <div className={block("case-desc")}>
          他们都在用快站公众号，扫码可体验
        </div>
        <div className={block("case-wrap")}>
          {CASE_DATA.map((item) => (
            <VerticalCard
              className={block("case-item")}
              imgUrl={item.img}
              title={item.title}
              imgStyle={{
                boxShadow: "0px 3px 20px 0px rgba(1, 73, 170, 0.1)",
                backgroundColor: "#fff",
                padding: "8px",
              }}
              align="center"
            />
          ))}
        </div>
        <button className={block("case-btn")} onClick={goWxList}>
          立即使用
          <Icon name="you" className={block("case-btn-icon")} />
        </button>
      </div>
      {/* <WxAdPop /> */}
      <ScrollBrand brandList={BrandList} />
      <WxOurInfomation />
      <Footer {...FOOTER_CONTENT} />
    </div>
  );
};

export default WxHome;
